import { render, staticRenderFns } from "./page-main-title.vue?vue&type=template&id=cb7278f0&scoped=true&lang=pug&"
import script from "./page-main-title.vue?vue&type=script&lang=js&"
export * from "./page-main-title.vue?vue&type=script&lang=js&"
import style0 from "./page-main-title.vue?vue&type=style&index=0&id=cb7278f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7278f0",
  null
  
)

export default component.exports